export default function initResultsCounterDownloads() {

    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

    const counterEl = document.getElementById('c-results-count');
    if (!counterEl) return;

    const updateCount = () => {
        const cards = document.querySelectorAll('.c-downloads-list .c-catalog-card, .c-downloads-list .c-product-doc-card');
        const total = cards.length;

        if (total === 0) {
            counterEl.innerHTML = '<strong>Nenhum item</strong> encontrado';
        } else if (total === 1) {
            counterEl.innerHTML = '<strong>1 item</strong> encontrado';
        } else {
            counterEl.innerHTML = `<strong>${total} itens</strong> encontrados`;
        }
    };

    // 1. Contagem inicial ao carregar a página
    updateCount();

    // 2. Conecta nos eventos oficiais do Ajax Search Pro
    const attachAspEvents = () => {
        // O ASP usa essa classe em todas as instâncias de busca
        const aspContainers = document.querySelectorAll('.asp_main_container');

        if (aspContainers.length === 0) {
            // Se o JS rodar antes do plugin montar o HTML, tenta de novo em 300ms
            setTimeout(attachAspEvents, 300);
            return;
        }

        aspContainers.forEach((el) => {
            // Evento oficial 1: O exato milissegundo em que a busca vai pro servidor
            el.addEventListener('asp_search_start', () => {
                counterEl.innerHTML = '<strong>Carregando...</strong>';
            });

            // Evento oficial 2: O exato milissegundo em que o servidor devolve a resposta
            el.addEventListener('asp_search_end', () => {
                // Dá 150ms apenas para o navegador desenhar os cards novos na tela
                setTimeout(() => {
                    updateCount();
                }, 150);
            });
        });
    };

    // Inicia a conexão
    attachAspEvents();
}